<template>
<!-- 甲方数据页面 -->
  <div id="CustomerOwnerDataReport" >
    <div id="right">
        <!-- 头部控件 --> 
        <HeadControl :optionsVal="true" :titleName="'甲方数据'" ref="HeadControl" @changeVal="changeVal" @changDate="changDate" @changePicker="changePicker"></HeadControl>
      <!-- 分布盒子 -->
      <div class="shortDes" v-if="headData.length">
        <div class="BoxLeft">
            <div class="BoxText">客户总数</div>
            <div class="BoxData">
                <div class="number">{{headData[0].count}}<i>个</i></div>
                <div class="DataImg">
                    <img :src="headData[0].itemIcon" alt="">
                </div>
            </div>
        </div>
        <div class="BoxRight">
            <div class="BoxText">按地区</div>
            <div class="regionData">
            <div class="BoxData">
                <div class="SmBoxData">
                <div class="region">国内</div>
                <div class="number">{{headData[1].count}}<i>个</i></div>                    
                </div>
                <div class="DataImg">
                    <img :src="headData[1].itemIcon" alt="">
                </div>
            </div>
            <div class="BoxData">
                <div class="SmBoxData">
                <div class="region">广东省</div>
                <div class="number">{{headData[2].count}}<i>个</i></div>                    
                </div>
                <div class="DataImg">
                    <img :src="headData[2].itemIcon" alt="">
                </div>
            </div>
            <div class="BoxData">
                <div class="SmBoxData">
                <div class="region">深圳市</div>
                <div class="number">{{headData[3].count}}<i>个</i></div>                    
                </div>
                <div class="DataImg">
                    <img :src="headData[3].itemIcon" alt="">
                </div>
            </div>                
            </div>                        
        </div>
      </div>
      <!-- 报表数据 -->
       <div>
        <CustomerOwnerDataEcharts :dataRange="dataRange" :CustomerDataList="CustomerDataList" :natureData="natureData" :IndustryData="IndustryData"></CustomerOwnerDataEcharts>
       </div>
    </div>    
  </div>
</template>

<script>
import CustomerOwnerDataEcharts from '@/components/ReportComponent/CustomerOwnerDataEcharts'
import HeadControl from '@/components/HeadControl'
import * as Urls from '@/helper/Urls';
export default {
components:{
    CustomerOwnerDataEcharts,
    HeadControl 
},  
data() {
    return {
      orgCode:'',
      dataRange:[],
      headData:[], // 头部数据
      CustomerDataList:[], // 客户数据
      natureData:[], // 性质数据 
      IndustryData:[] // 行业数据
    };
},  
mounted(){
    // let start = new Date();
    // let end = new Date();
    // start.setDate(1);
    // start.setHours(0);
    // start.setSeconds(0);
    // start.setMinutes(0);
    // start.setTime(start.getTime());
    // this.dataRange = [this.$root.formatDay(start), this.$root.formatDay(end)];
},  
methods:{
    init(){
        this.$refs.HeadControl.getDatas('');
        this.$refs.HeadControl.getSysOrg()
    },
    // 获取组织架构ID
    changeVal(val) {
       this.orgCode = val;
       this.getHeadData()
       this.getCustomerData()
       this.getNature()
       this.getIndustry()
    },
    changDate(val){
       this.dataRange=val
       this.getHeadData()
       this.getCustomerData()
       this.getNature()
       this.getIndustry()       
    },
    // 获取总数据 
    getHeadData(){
        let _this = this
        let url = Urls.getEchartsReportItemDataByCustomer
        let params =  {
            orgCode:this.orgCode || '',
            startTime:this.dataRange.length?this.dataRange[0]:'',
            endTime:this.dataRange.length?this.dataRange[1]:'',
            itemCode:'CUSTOMER_DISTRICT'
        }
        this.$root.doPost(url,params,function(server_data){
            // 用户没有登录
           if( !_this.$root.isUserLogin(server_data)){
           return;
         }

         // 应用错误
         if(server_data.error){
             _this.$root.showGlobalError(server_data.error);
             return;
         }
         _this.headData = server_data.data.reportList       
        })
    },
    // 获取客户数据
    getCustomerData(){
        let _this = this
        let url = Urls.getEchartsCustomerCountReportItemData
        let params = {
            orgCode:this.orgCode || '',
            startTime:this.dataRange.length?this.dataRange[0]:'',	
            endTime:this.dataRange.length?this.dataRange[1]:'',
            itemCode:'CUSTOMER_ACC_DATA'            
        }
        this.$root.doPost(url,params,function(server_data){
            // 用户没有登录
           if( !_this.$root.isUserLogin(server_data)){
           return;
         }

         // 应用错误
         if(server_data.error){
             _this.$root.showGlobalError(server_data.error);
             return;
         }
            _this.CustomerDataList =  server_data.data          
        })
    },
    //  获取性质
    getNature(){
        let _this = this;
        let url = Urls.getEchartsCustomerNatureReportItemData
        let params =  {
            orgCode:this.orgCode || '',
            startTime:this.dataRange.length?this.dataRange[0]:'',	
            endTime:this.dataRange.length?this.dataRange[1]:'',
            itemCode:'CUSTOMER_NATURE'
        }
        this.$root.doPost(url,params,function(server_data){
            // 用户没有登录
           if( !_this.$root.isUserLogin(server_data)){
           return;
         }

         // 应用错误
         if(server_data.error){
             _this.$root.showGlobalError(server_data.error);
             return;
         }   
         _this.natureData = server_data.data    
        })
    },
    // 获取行业
    getIndustry(){
        let _this = this
        let url = Urls.getEchartsCustomerIndustryReportItemData
        let params = {
            orgCode:this.orgCode || '',
            startTime:this.dataRange.length?this.dataRange[0]:'',	
            endTime:this.dataRange.length?this.dataRange[1]:'',
            itemCode:'CUSTOMER_INDUSTRY'           
        }
        this.$root.doPost(url,params,function(server_data){
            // 用户没有登录
           if( !_this.$root.isUserLogin(server_data)){
           return;
         }

         // 应用错误
         if(server_data.error){
             _this.$root.showGlobalError(server_data.error);
             return;
         }       
            _this.IndustryData =  server_data.data
        })
    },
    // 时间
    changePicker(val){
       this.dataRange = val
       this.getHeadData()
       this.getCustomerData()
       this.getNature()
       this.getIndustry()        
    },
    getOrgCode(){
        this.$refs.HeadControl.getSysOrg()
    }
},
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
#CustomerOwnerDataReport{   
    #right{
    box-sizing: border-box;
     .shortDes{
        display: flex;
        margin-top: 0.29rem;
        .BoxLeft{
            height: 1.5rem;
            width: 25%;
            margin-right: 0.24rem;
            background-color: #fff;
            -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
             box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
             border-radius:0.1rem;
            .BoxText{
                font-size: 0.14rem;
                margin-top: 0.3rem;
                margin-left: 0.3rem;
                color:#333333;
            }
            .BoxData{
                display: flex;
                height: 0.66rem;
                margin-left: 0.3rem;
                margin-right: 0.2rem;
                align-items: center;
                justify-content: space-between;
                .number{
                    line-height: 0.66rem;
                    // margin-right: 2.15rem;
                    font-size: 0.3rem;
                    color:#333333;
                    i{
                         font-style: normal;
                         font-size:0.12rem;
                         color:#666666;
                    }
                }
                .DataImg{
                    height: 0.66rem;
                    width: 0.66rem;
                    border-radius:50%;
                    .img{
                        width: 100%;
                        height:100%;
                    }
                }
             }
        }
        .BoxRight{
            width: 80%;
            height: 1.5rem;
            // width: 12rem;
            background-color: #fff;
            -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
             box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
             border-radius:0.1rem;
            .BoxText{
                font-size: 0.18rem;
                margin-top: 0.24rem;
                margin-left: 0.3rem;
                color:#333333;
            }            
            .regionData{
             display: flex;
             justify-content: space-between;
            .BoxData{
                display: flex;
                align-items: center;
                height: 0.78rem;
                margin-left: 0.3rem;
                width: 33.33%;
                .SmBoxData{
                    // margin-right: 0.45rem;
                .region{
                    font-size: 0.14rem;
                    color:#666666;
                }                    
                .number{
                    // line-height: .78rem;
                    margin-right: 1.51rem;
                    font-size: 0.26rem;
                    color:#333333;
                    i{
                         font-style: normal;
                         font-size:0.12rem;
                    }
                }                    
                }
                .DataImg{
                    height: 0.78rem;
                    width: 1.08rem;
                    // border-radius:50%;
                    .img{
                        height: 100%;
                        width: 100%;
                    }
                }
             }
             .BoxData:nth-child(1){
                border-right: 1px solid #f3f3f3;
    
             }
             .BoxData:nth-child(2){
                border-right: 1px solid #f3f3f3;
             }             
            }
        }
     }
    }
}
 @media screen and (max-width: 768px) {
   #CustomerOwnerDataReport {
    background-color: #f5f5f5;
     #right {
        box-sizing: border-box;
        .shortDes{
          display: flex;  
          flex-direction: column;
          margin-top: 0.14rem;
          padding: 0 0.12rem;
          height: 5rem;
          .BoxLeft{
            width: 100%;
            margin: 0;
            border: none;
            .BoxText{
                font-size: 0.2rem;
                margin-top: 0.15rem;
                margin-left: 0.2rem;
                font-weight: 800;
            }
            .BoxData{
                margin-top: 0;
                margin-left: 0;
                // width: 100%; 
                margin: 0.1rem 0.2rem;
                .number{
                    margin-right: 0;
                }
            }
          }
          .BoxRight{
            width:100%;
            margin-top: 0.14rem;
            height: 3.5rem;
            border: none;
            .BoxText{
                font-size: 0.2rem;
                margin-top: 0.15rem;
                margin-left: 0.2rem !important;
                font-weight: 800;
            }
            .regionData{
                flex-direction: column;
                padding: 0 0.2rem;
                height: 2.95rem;
                .BoxData{
                    margin-left: 0 !important;
                    margin-top: 0;
                    width: 100%;
                    justify-content: inherit !important;
                    align-items: center;
                    padding: 0.1rem 0;
                    // margin-left: 0.25rem;
                    .SmBoxData{
                        .region{
                            font-size: 0.14rem;
                            margin-top: 0;
                        }
                        .number{
                            i{
                                padding-left: 0.05rem
                            }
                        }
                    }
                }
             .BoxData:nth-child(1){
                padding-right: 0;
                border-right: none;
                border-bottom: 1px solid #f3f3f3;
    
             }
             .BoxData:nth-child(2){
                padding-right: 0;
                border-right: none;
                border-bottom: 1px solid #f3f3f3;
             }                 
            }
          }
        }
    }
  }
 }
 @media screen and (max-width: 1366px) {
    #CustomerOwnerDataReport{
       #right{
        .shortDes{
            .BoxLeft{
                .BoxData{
                    .number{
                        display: flex;
                        font-size: 0.26rem;
                    }
                    .DataImg{
                        margin-right: 0.1rem;
                    }
                }
            }
            .BoxRight{
                 .BoxText{
                  margin-left: 0.25rem;
                }
                .regionData{
                    .BoxData{
                        margin-left: 0.25rem;
                        justify-content: unset;
                        .SmBoxData{
                            margin-right: 0;
                            .number{
                                display: flex;
                                align-items: center;
                                font-size: 0.26rem;
                                margin-right: 0.5rem;
                            }
                        }
                        // .DataImg{
                        //     height: 0.6rem;
                        //     width: 0.6rem;
                        //     img{
                        //         width: 100%;
                        //         height: 100%;
                        //     }
                        // }
                    }
                }
            }
        }
       } 
    }
}
</style>
<style lang="scss">
 @media screen and (max-width: 768px) {
    #CustomerOwnerDataReport{
        #right {
            .queryCondition {
                margin-bottom: 0;
            }
        }
    }
 }
</style>



// WEBPACK FOOTER //
// CustomerOwnerDataReportOne.vue?d1dedc80